import React from 'react'
import { MDBIcon } from 'mdbreact';
import { useQuery } from '@apollo/react-hooks';
import graphql from 'graphql-tag'

const NavbarSocials = () => {
    const { data, loading, error } = useQuery(graphql`
        query{
            socialAccount{
                instagram
                twitter
                facebook
                pinterest
            }
        }
    `) 
    
    if(loading) return <p>loading</p>
    if(error) return <p>error</p>

    const social = data.socialAccount

    return (
        <>
        <a className="black-text" href={social.facebook}>
            <MDBIcon size="lg" fab icon="facebook-f"/>
        </a>
        <a className="black-text" href={social.pinterest}>
            <MDBIcon size="lg" fab icon="pinterest-p"/>
        </a>
        <a className="black-text" href={social.instagram}>
            <MDBIcon size="lg" fab icon="instagram" />                    
        </a>
        <a className="black-text" href={social.twitter}>
            <MDBIcon size="lg" fab icon="twitter"/>
        </a>   
        </>
    )
}

export default NavbarSocials
